// Tab-separated text, the format Excel, Numbers and Google Sheets put on the
// clipboard for a block of cells. Fields holding a tab, line break or leading
// quote are wrapped in quotes with inner quotes doubled, as Excel does.

function needsQuotes(field) {
    return /[\t\r\n]/.test(field) || field.startsWith('"');
}

function quote(field) {
    return `"${field.replace(/"/g, '""')}"`;
}

/** rows: string[][] -> clipboard text (no trailing newline). */
export function serializeTsv(rows) {
    return rows
        .map((cells) => cells
            .map((cell) => {
                const field = cell == null ? '' : String(cell);
                return needsQuotes(field) ? quote(field) : field;
            })
            .join('\t'))
        .join('\n');
}

/**
 * Clipboard text -> string[][]. Accepts LF, CRLF or CR line endings and
 * quoted fields with embedded tabs, line breaks and doubled quotes. The
 * single trailing line break spreadsheets append is ignored.
 */
export function parseTsv(text) {
    const source = String(text ?? '');
    if (source === '') return [];
    const rows = [];
    let cells = [];
    let field = '';
    let index = 0;
    let quoted = false;
    let fieldStart = true;

    const endField = () => {
        cells.push(field);
        field = '';
        fieldStart = true;
    };
    const endRow = () => {
        endField();
        rows.push(cells);
        cells = [];
    };

    while (index < source.length) {
        const char = source[index];
        if (quoted) {
            if (char === '"' && source[index + 1] === '"') {
                field += '"';
                index += 2;
                continue;
            }
            if (char === '"') {
                quoted = false;
                index += 1;
                continue;
            }
            field += char;
            index += 1;
            continue;
        }
        if (char === '"' && fieldStart) {
            quoted = true;
            fieldStart = false;
            index += 1;
            continue;
        }
        if (char === '\t') {
            endField();
            index += 1;
            continue;
        }
        if (char === '\r' || char === '\n') {
            endRow();
            index += char === '\r' && source[index + 1] === '\n' ? 2 : 1;
            continue;
        }
        field += char;
        fieldStart = false;
        index += 1;
    }
    // Text that does not end with a line break still has a final row.
    if (!fieldStart || cells.length > 0 || field !== '') endRow();
    return rows;
}
